export default __webpack_public_path__ + "static/media/PowellCatLocation-05.3cb8cd24.jpg";